<template>
  <div class="w-full flex flex-col mt-5">
    <h2 class="text-center mb-4 font-bold">Progreso de Salud</h2>

    <!-- Progreso de Actividad Física -->
    <div class="w-full flex flex-col items-center mb-4">
      <h4>Actividad Física Semanal</h4>
      <p>Progreso: {{ actividadActual }} / {{ actividadMeta }} minutos</p>
      <div class="w-full bg-gray-200 rounded-full dark:bg-gray-700">
        <div class="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
          role="progressbar" :style="{ width: `${progresoActividad * 100}%` }" aria-valuenow="progresoActividad * 100"
          aria-valuemin="0" aria-valuemax="100">
          {{ (progresoActividad * 100).toFixed(1) }}%
        </div>
      </div>
    </div>

    <!-- Progreso de Consumo Calórico -->
    <div class="w-full flex flex-col items-center mb-4">
      <h4>Consumo Calórico Diario</h4>
      <p>Progreso: {{ caloriasActual }} / {{ caloriasMeta }} kcal</p>
      <div class="w-full bg-gray-200 rounded-full dark:bg-gray-700">
        <div class="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full" role="progressbar" :style="{ width: `${progresoCalorias * 100}%` }"
          aria-valuenow="progresoCalorias * 100" aria-valuemin="0" aria-valuemax="100">
          {{ (progresoCalorias * 100).toFixed(1) }}%
        </div>
      </div>
    </div>

    <!-- Reducción de Medicamentos y Vitaminas -->
    <div class="w-full flex flex-col items-center mb-4">
      <h4>Reducción en Medicamentos y Vitaminas</h4>
      <p>Progreso: {{ medicamentosReducidos }} / {{ medicamentosTotales }}</p>
      <div  class="w-full bg-gray-200 rounded-full dark:bg-gray-700">
        <div class="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full" role="progressbar" :style="{ width: `${progresoMedicamentos * 100}%` }"
          aria-valuenow="progresoMedicamentos * 100" aria-valuemin="0" aria-valuemax="100">
          {{ (progresoMedicamentos * 100).toFixed(1) }}%
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth } from 'firebase/auth'; // Importamos getAuth de Firebase
import {collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase"; // Ajusta la importación según tu configuración

export default {
  name: "ProgresoSalud",
  data() {
    return {
      pacienteId: null, // El pacienteId lo obtendremos del usuario autenticado
      actividadActual: 0,
      actividadMeta: 300,
      caloriasActual: 0,
      caloriasMeta: 2000,
      medicamentosReducidos: 0,
      medicamentosTotales: 10,
    };
  },
  computed: {
    progresoActividad() {
      return this.actividadMeta ? this.actividadActual / this.actividadMeta : 0;
    },
    progresoCalorias() {
      return this.caloriasMeta ? this.caloriasActual / this.caloriasMeta : 0;
    },
    progresoMedicamentos() {
      return this.medicamentosTotales
        ? this.medicamentosReducidos / this.medicamentosTotales
        : 0;
    },
  },
  async mounted() {
    this.obtenerPacienteId(); // Obtén el pacienteId del usuario logueado
    if (this.pacienteId) {
      await this.cargarProgresoSalud(); // Cargar el progreso de salud una vez que tengamos el pacienteId
    }
  },
  methods: {
    // Método para obtener el pacienteId del usuario autenticado
    obtenerPacienteId() {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user) {
        this.pacienteId = user.uid; // El pacienteId es el UID del usuario autenticado
      } else {
        console.error("No hay un usuario autenticado.");
      }
    },
    async cargarProgresoSalud() {
      try {
        if (!this.pacienteId) {
          console.error("No se ha encontrado el pacienteId.");
          return;
        }

        // Obtener las actividades del paciente
        const actividadesRef = collection(db, `pacientes/${this.pacienteId}/actividades`);
        const querySnapshot = await getDocs(actividadesRef);

        // Sumar los minutos de actividad física
        let totalMinutos = 0;
        querySnapshot.forEach((doc) => {
          const actividad = doc.data();
          totalMinutos += actividad.duracion || 0;
        });

        // Actualizar el valor de actividadActual
        this.actividadActual = totalMinutos;

      } catch (error) {
        console.error("Error al cargar los datos de progreso de salud:", error);
      }
    },
  },
};
</script>

<style scoped></style>
